module.exports = __webpack_public_path__ + "media/images/flags/16/Guinea-2c62771a07ff6b7c94b323f5a84d4721.png";